<section class="immunotherapy-wrapper"
         *ngIf="config"
         [ngClass]="{'view-mode card-layout':viewMode,'open':show,'compare-mode':compareMode}">
  <section class="immunotherapy-title" (click)="show=!viewMode || !show">
    <span class="immunotherapy-title-text">{{'Immunotherapy related findings' | stringTranslate}}</span>
    <div class="arrow fa fa-chevron-up"></div>
    <gen-button *ngIf="editAllowed"
                class="Auto_Edit_Button"
                [type]="'emphasis'"
                [active]="edit"
                [iconClass]="'icon__edit'"
                [text]="'Edit' | stringTranslate"
                (click)="setEditStatus(true)"></gen-button>
  </section>
  <section class="options-wrapper">
    <section class="single-option" *ngFor="let valueObject of values|objectToArray;trackBy: valueObject?.key">
      <span class="option-label Auto_Label_{{valueObject.key}}">{{(payloads[valueObject.key]?.label) | stringTranslate}}</span>
      <span class="option-value Auto_Value_{{valueObject.key}}"
            genTooltip
            genEllipsis
            [tooltipPosition]="'RIGHT'"
            [tooltipText]="getText(valueObject.key)"
            [tooltipShow]="payloads[valueObject.key]?.showTooltip"
            (tooltipStateEmit)="setTooltipStatus(valueObject.key,$event)"
            *ngIf="!(edit && payloads[valueObject.key]?.editable)">{{getText(valueObject.key)}}</span>
      <gen-finding-input
        class="option-value"
        *ngIf="edit && payloads[valueObject.key]?.editable"
        (validationUpdate)="updateValidation(valueObject.key,$event)"
        [editable]="editAllowed"
        [key]="valueObject.key"
        [valueObject]="valueObject.edit || valueObject.value"
        [changed]="valueObject.value.changed"
        [type]="payloads[valueObject.key]?.type"
        [levels]="payloads[valueObject.key]?.levels"
        [min]="payloads[valueObject.key]?.min"
        [max]="payloads[valueObject.key]?.max"
        [defaultValue]="payloads[valueObject.key]?.defaultValue"
        [defaultLevel]="payloads[valueObject.key]?.defaultLevel"
        [triggers]="payloads[valueObject.key]?.triggers"
        [levelAttributes]="payloads[valueObject.key]?.levelAttributes"
        [valueAttributes]="payloads[valueObject.key]?.valueAttributes"
        [regex]="payloads[valueObject.key]?.regex"
      ></gen-finding-input>
    </section>
    <section class="buttons-wrapper" *ngIf="edit && !compareMode">
      <gen-button class="Auto_Cancel_Button"
                  (click)="cancelEdit()"
                  [type]="'quite'"
                  [text]="'Cancel' | stringTranslate"></gen-button>
      <gen-button class="Auto_Save_Button"
                  [type]="'primary'"
                  [text]="'Save changes' | stringTranslate"
                  (click)="updateValue()"></gen-button>
    </section>
  </section>
</section>
